import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { OpeningParagraphProps } from './opening-paragraph.types';
import { PAtom } from '@atoms/text-atoms/text-atoms';

const OpeningParagraph: React.FC<OpeningParagraphProps> = ({
  openingParagraph = '',
  className,
}) => {
  return (
    <div data-testid="opening-paragraph" className={className}>
      <PAtom>{openingParagraph}</PAtom>
    </div>
  );
};

const StyledOpeningParagraph = styled(OpeningParagraph)`
  background: white;
  text-align: left;
  padding-top: 40px;

  ${PAtom} {
    overflow: hidden;
    ${vars.fontSize7}
    line-height: 1.2;
    margin: 0;
    font-weight: 500;
    letter-spacing: -0.04em;
  }
`;

export default StyledOpeningParagraph;
